module.exports = __webpack_public_path__ + "media/images/thumb_20_staff_list-d9a0072c.jpeg";